export const getServicesWithPrice = (business, getAllServices, getAllPrices) => async (priceListId) => {
    const prices = await getAllPrices(business, priceListId)
    const services = await getAllServices()
    return services.map(s => ({
        service: s,
        price: prices.find(p => p.service_id === s.id)
    }))
}
